// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ManifiestosDashboardBase from '../../components/administration/manifests/ManifestDashboardBase';

const ManifiestosExternosPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <ManifiestosDashboardBase
                serProInt={false}
                tipoServicioCodigo="TRANSPORTE_PERSONAL"
                title="Gestión de Manifiestos Externos"
            />
        </Box>
    );
};

export default ManifiestosExternosPage;
